import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { type AppointmentFormValues, ShipmentRepository } from '../infra/ShipmentRepository'

export type UpdateAppointmentParams = {
  shipmentUUID: string
  stopIndex: number
  data: AppointmentFormValues
}

export type UpdateAppointmentFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function updateAppointmentFactory({
  shipmentRepository,
}: UpdateAppointmentFactoryDependencies) {
  return async function submit(params: UpdateAppointmentParams, config?: { signal?: AbortSignal }) {
    const { shipmentUUID, stopIndex, data } = params
    try {
      return await shipmentRepository.updateAppointment({ shipmentUUID, stopIndex, data, config })
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not update appointment', { cause: error as Error })
    }
  }
}

export function updateAppointment(
  params: UpdateAppointmentParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const submit = updateAppointmentFactory({ shipmentRepository })

  return submit(params, config)
}
